module.exports = __webpack_public_path__ + "img/diskette.0dc70dd5.svg";